<template>
  <div class="component-upload-image" style="zoom: 1.2">
    <el-upload
      multiple
      :action="uploadImgUrl"
      list-type="picture-card"
      :on-success="handleUploadSuccess"
      :before-upload="handleBeforeUpload"
      :limit="limit"
      :data="{
        path: 'PC_File',
      }"
      :on-error="handleUploadError"
      :on-exceed="handleExceed"
      ref="imageUpload"
      :on-remove="handleDelete"
      :show-file-list="true"
      :headers="headers"
      :file-list="fileList"
      :on-preview="handlePictureCardPreview"
      :class="{ hide: this.fileList.length >= this.limit }"
      style="zoom: 0.6"
      accept=".png,.jpg,.jpeg"
    >
      <i class="el-icon-plus"></i>
    </el-upload>

    <!-- 上传提示 -->
    <div class="el-upload__tip" slot="tip" v-if="showTip">
      请上传
      <template v-if="fileSize">
        大小不超过 <b style="color: #f56c6c">{{ fileSize }}MB</b>
      </template>
      <template v-if="fileType">
        格式为 <b style="color: #f56c6c">{{ fileType.join("/") }}</b>
      </template>
      的文件
    </div>

    <el-image-viewer
      v-if="dialogVisible"
      :on-close="closeImgViewer"
      :url-list="imagePreviewUrls"
      :z-index="3000"
      :initial-index="initialImgPreviewIndex"
    />

    <el-button
      v-if="isShowHighSpeed"
      type="primary"
      @click="open_view1"
      style="margin-right: 10px"
      >高拍仪</el-button
    >

    <el-link
      v-if="isShowHighSpeed"
      href="https://bankagro.obs.cn-north-9.myhuaweicloud.com/plug-in/WebCamera_V1.2.5_base.exe"
      target="_blank"
      type="primary"
      >高拍仪插件下载<i class="el-icon-download el-icon--right"></i>
    </el-link>
    <span v-if="isShowHighSpeed"
      >(该插件仅支持型号为S200L和JS1260的良田高拍仪)</span
    >

    <el-dialog
      :visible.sync="dialogVisible1"
      width="40%"
      title="高拍仪"
      :append-to-body="true"
      style="z-index: 20000"
    >
      <div ref="gpyImg">
        <img
          src="http://localhost:38088/video=stream&camidx=0"
          id="view1"
          v-if="dialogVisible1"
          style="width: 100%; height: auto; margin-top: 20px"
          @error="gpyErr"
          ref="gpyImg1"
        />
      </div>
      <div class="demo-image__preview">
        <el-upload
          action="#"
          list-type="picture-card"
          :file-list="fileList1"
          :auto-upload="false"
          style="zoom: 0.6"
          class="hide"
        >
          <i slot="default" class="el-icon-plus"></i>
          <div slot="file" slot-scope="{ file }">
            <img
              class="el-upload-list__item-thumbnail"
              :src="file.url"
              alt=""
            />
            <span class="el-upload-list__item-actions">
              <span
                class="el-upload-list__item-preview"
                @click="handlePictureCardPreviewGpy(file)"
              >
                <i class="el-icon-zoom-in"></i>
              </span>
              <!-- <span
          v-if="!disabled"
          class="el-upload-list__item-delete"
          @click="handleDownloadGpy(file)"
        >
          <i class="el-icon-download"></i>
        </span> -->
              <span
                class="el-upload-list__item-delete"
                @click="handleDeleteGpy(file)"
              >
                <i class="el-icon-delete"></i>
              </span>
            </span>
          </div>
        </el-upload>
        <el-image-viewer
          v-if="dialogVisibleGpy"
          :on-close="closeImgViewerGpy"
          :url-list="imagePreviewUrlsGpy"
          :z-index="3000"
          :initial-index="initialImgPreviewIndexGpy"
        />
      </div>
      <div
        style="
          display: flex;
          align-items: center;
          margin-top: 20px;
          justify-content: center;
        "
      >
        <el-button
          type="primary"
          size="mini"
          @click="rotate(90)"
          icon="el-icon-refresh-left"
          >左转</el-button
        >
        <el-button
          type="primary"
          size="mini"
          @click="rotate(270)"
          icon="el-icon-refresh-right"
          >右转</el-button
        >
        <el-button
          type="primary"
          size="mini"
          @click="photograph"
          icon="el-icon-camera"
          >拍照</el-button
        ><el-button
          type="primary"
          size="mini"
          @click="gpySave"
          icon="el-icon-folder-add"
          >保存</el-button
        >
      </div>
    </el-dialog>

    <!-- <el-dialog
      :visible.sync="dialogVisible"
      title="预览"
      width="800"
      append-to-body
    >
      <img
        :src="dialogImageUrl"
        style="display: block; max-width: 100%; margin: 0 auto"
      />
    </el-dialog> -->
  </div>
</template>

<script>
import ElImageViewer from "element-ui/packages/image/src/image-viewer"
import mainReqUrl from "../../util/mainReqUrl"

export default {
  components: {
    ElImageViewer,
  },
  props: {
    value: [String, Object, Array],
    // 图片数量限制
    limit: {
      type: Number,
      default: 50,
    },
    // 大小限制(MB)
    fileSize: {
      type: Number,
      default: 2,
    },
    // 文件类型, 例如['png', 'jpg', 'jpeg']
    fileType: {
      type: Array,
      default: () => ["png", "jpg", "jpeg"],
    },
    // 是否显示提示
    isShowTip: {
      type: Boolean,
      default: true,
    },
    // 是否显示高拍仪
    isShowHighSpeed: {
      type: Boolean,
      default: false,
    },
  },
  data () {
    return {
      // 高拍仪弹窗(true打开/false关闭)
      dialogVisible1: false,
      gpyImgList: [], //高拍仪图片

      dialogVisibleGpy: false,
      // ----------------------
      number: 0,
      uploadList: [],
      dialogImageUrl: "",
      dialogVisible: false,
      hideUpload: false,
      baseUrl: "",
      uploadImgUrl: "/prod-api/common/upload", // 上传的图片服务器地址
      headers: {
        Authorization: "Bearer " + localStorage.getItem("token"),
      },
      fileList: [],
      initialImgPreviewIndex: 0, // 预览打开看到的图片下标
      imagePreviewUrls: [], // 预览图片的下标

      fileList1: [], //高拍仪展示列表
      initialImgPreviewIndexGpy: 0, // 预览打开看到的图片下标
      imagePreviewUrlsGpy: [], // 预览图片的下标

      // ---------------------
    }
  },
  watch: {
    value: {
      handler (val) {
        if (val) {
          // 首先将值转为数组
          const list = Array.isArray(val) ? val : this.value.split(",")
          // 然后将数组转为对象数组
          this.fileList = list.map((item) => {
            if (typeof item === "string") {


              item = { name: item, url: item }
            }

            return item
          })
        } else {
          this.fileList = []
          return []
        }
      },
      deep: true,
      immediate: true,
    },
  },

  computed: {
    // 是否显示提示
    showTip () {
      return this.isShowTip && (this.fileType || this.fileSize)
    },
  },

  methods: {
    // 左转
    rotate (angle) {
      let data = { camidx: "0", rotate: String(angle) }
      this.$.ajax({
        url: "http://127.0.0.1:38088/video=rotate",
        data: JSON.stringify(data),
        dataType: "json",
        contentType: "application/x-www-form-urlencoded",
        type: "post",
        success: function (result) { },
      })
    },
    gpyErr () {
      this.$modal.msgWarning("您是否已安装高拍仪插件，如果没安装请安装插件；如果已安装请重启高拍仪并刷新页面后重试")
      this.dialogVisible1 = false
    },

    // 高拍仪拍照
    photograph () {
      let data = {
        filepath: "base64",
        rotate: "0",
        cutpage: "0",
        camidx: "0",
        ColorMode: "0",
        quality: "3",
      }
      var _this = this

      this.$.ajax({
        url: "http://127.0.0.1:38088/video=grabimage",
        data: JSON.stringify(data),
        dataType: "json",
        contentType: "application/x-www-form-urlencoded",
        type: "post",
        success: function (result) {
          let base64 = "data:image/jpg;base64," + result.photoBase64
          let blob = _this.dataURLtoBlob(base64)
          // 拿到文件名
          // let fileName = "电子签名.jpg";

          // 2，在转为 file类型
          let file = _this.blobToFile(blob)

          const formData = new FormData()
          formData.append("file", file)
          uploadFile(formData).then((res) => {
            let item = { name: res.fileUrls[0], url: res.fileUrls[0] }
            _this.fileList1.push(item)
            // _this.gpyImgList.push(res.fileUrls[0]);
          })
        },
      })
    },
    // 高拍仪保存
    gpySave () {
      if (this.fileList1.length > 0) {


        this.fileList = this.fileList.concat(this.fileList1)


        this.$emit("input", this.listToString(this.fileList))
        this.imagePreviewUrls = this.listToString(this.fileList).split(",")
        this.gpyClose()
      } else {
        this.$modal.msgWarning("请先拍照再保存！")
      }
    },
    // 高拍仪关闭
    gpyClose () {
      // let data = {"camidx": "0"}
      // this.$.ajax({
      //   url: "http://127.0.0.1:38088/video=close",
      //   data: JSON.stringify(data),
      //   dataType: "json",
      //   contentType: "application/x-www-form-urlencoded",
      //   type: "post",
      //   success: function (result) {

      //   },
      // });
      this.fileList1 = []
      this.dialogVisible1 = false
    },
    //1,先将base64转换为blob
    dataURLtoBlob (baseurl) {
      var arr = baseurl.split(","),
        mime = arr[0].match(/:(.*?);/)[1],
        bstr = atob(arr[1]),
        n = bstr.length,
        u8arr = new Uint8Array(n)
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n)
      }
      return new Blob([u8arr], { type: mime })
    },
    //2,再将blob转换为file
    blobToFile (theBlob, fileName) {
      theBlob.lastModifiedDate = new Date() // 文件最后的修改日期
      theBlob.name = fileName // 文件名
      return new File([theBlob], fileName, {
        type: theBlob.type,
        lastModified: Date.now(),
      })
    },

    // 打开高拍仪
    open_view1 () {
      // this.dialogVisible1 = true;
      var _this = this
      this.$.ajax({
        url: "http://127.0.0.1:38088/device=isconnect",
        dataType: "json",
        contentType: "application/x-www-form-urlencoded",
        type: "post",
        success: function (result) {
          if (result.data == '1') {
            _this.dialogVisible1 = true
          } else {
            _this.$modal.msgWarning("高拍仪设备已断开")
          }
        },
        error: function (err) {
          console.log(1111)
        }
      })
    },

    // 高拍仪图片预览
    handlePictureCardPreviewGpy (file) {
      this.imagePreviewUrlsGpy = this.listToString(this.fileList1).split(",")
      let index = this.imagePreviewUrlsGpy.indexOf(file.url)
      if (index >= 0) {
        this.initialImgPreviewIndexGpy = index
      }
      this.dialogVisibleGpy = true
    },
    closeImgViewerGpy () {
      this.dialogVisibleGpy = false
    },
    // 删除高拍仪图片
    handleDeleteGpy (file) {
      console.log(file)
      const findex = this.fileList1.map((f) => f.name).indexOf(file.name)
      if (findex > -1) {
        this.fileList1.splice(findex, 1)
        // this.$emit("input", this.listToString(this.fileList1));
        // this.$emit("input", this.fileList);
      }

      // 删除预览数组对应的图片
      let index = this.imagePreviewUrlsGpy.indexOf(file.url)
      if (index > -1) {
        this.imagePreviewUrlsGpy.splice(index, 1)
      }
    },

    // ===========================

    // 图片预览
    handlePictureCardPreview (file) {
      console.log(file)
      let index = this.imagePreviewUrls.indexOf(file.url)
      if (index >= 0) {
        this.initialImgPreviewIndex = index
      }
      this.dialogVisible = true
    },
    closeImgViewer () {
      this.dialogVisible = false
    },
    // 上传前loading加载
    handleBeforeUpload (file) {
      let isImg = false
      if (this.fileType.length) {
        let fileExtension = ""
        if (file.name.lastIndexOf(".") > -1) {
          fileExtension = file.name.slice(file.name.lastIndexOf(".") + 1)
        }
        isImg = this.fileType.some((type) => {
          if (file.type.indexOf(type) > -1) return true
          if (fileExtension && fileExtension.indexOf(type) > -1) return true
          return false
        })
      } else {
        isImg = file.type.indexOf("image") > -1
      }

      if (!isImg) {
        this.$modal.msgError(
          `文件格式不正确, 请上传${this.fileType.join("/")}图片格式文件!`
        )
        return false
      }
      if (this.fileSize) {
        const isLt = file.size / 1024 / 1024 < this.fileSize
        if (!isLt) {
          this.$modal.msgError(`上传图片大小不能超过 ${this.fileSize} MB!`)
          return false
        }
      }
      this.$modal.loading("正在上传图片，请稍候...")

      this.number++
    },
    // 文件个数超出
    handleExceed () {
      this.$modal.msgError(`上传文件数量不能超过 ${this.limit} 个!`)
    },
    // 上传成功回调
    handleUploadSuccess (res, file) {
      if (res.code === 200) {
        this.uploadList.push({ name: file.uid, url: res.fileUrls[0] })

        this.uploadedSuccessfully()
      } else {
        this.number--
        this.$modal.closeLoading()
        this.$modal.msgError(res.msg)
        this.$refs.imageUpload.handleRemove(file)
        this.uploadedSuccessfully()
      }
    },
    // 删除图片
    handleDelete (file) {
      console.log(file)
      const findex = this.fileList.map((f) => f.name).indexOf(file.name)
      if (findex > -1) {
        this.fileList.splice(findex, 1)
        this.$emit("input", this.listToString(this.fileList))
        // this.$emit("input", this.fileList);
      }

      // 删除预览数组对应的图片
      let index = this.imagePreviewUrls.indexOf(file.url)
      if (index > -1) {
        this.imagePreviewUrls.splice(index, 1)
      }
    },
    // 上传失败
    handleUploadError () {
      this.$modal.msgError("上传图片失败，请重试")
      this.$modal.closeLoading()
    },
    // 上传结束处理
    uploadedSuccessfully () {
      if (this.number > 0 && this.uploadList.length === this.number) {
        this.fileList = this.fileList.concat(this.uploadList)
        this.uploadList = []
        this.number = 0
        this.$emit("input", this.listToString(this.fileList))
        console.log(this.fileList)
        console.log(this.listToString(this.fileList))
        this.imagePreviewUrls = this.listToString(this.fileList).split(",") // 预览图片的数组
        // this.$emit("input", this.fileList);
        this.$modal.closeLoading()
      }
    },
    // // 预览
    // handlePictureCardPreview(file) {
    //   this.dialogImageUrl = file.url;
    //   this.dialogVisible = true;
    // },
    // 对象转成指定字符串分隔
    listToString (list, separator) {
      let strs = ""
      separator = separator || ","
      for (let i in list) {
        if (list[i].url) {
          strs += list[i].url + separator
        }
      }
      return strs != "" ? strs.substr(0, strs.length - 1) : ""
    },
  },
};
</script>
<style scoped>
/* // .el-upload--picture-card 控制加号部分 */
::v-deep.hide .el-upload--picture-card {
  display: none;
}

/* // 去掉动画效果 */
::v-deep .el-list-enter-active,
::v-deep .el-list-leave-active {
  transition: all 0s;
}

::v-deep .el-list-enter,
.el-list-leave-active {
  opacity: 0;
  transform: translateY(0);
}

::v-deep .el-upload-list__item div,
.el-upload-list__item div img {
  width: 100%;
  height: 100%;
}
</style>
